// standard imports
import React from 'react';
import ReactDOM from 'react-dom/client';

import { BrowserRouter, Routes, Route } from "react-router-dom";
// component imports
import App from './App';
import Landing from './components/Landing.js';
// style imports
import './styles/index.css';
import './styles/NavBar.css';
import './styles/Landing.css';
import './styles/LandingIntro.css';
import './styles/Content.css';
import './styles/Footer.css';
import './styles/keyframes.css';
import './styles/scrollbar.css';
import './styles/FAQs.css';
// import reportWebVitals from './reportWebVitals';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />}>
          <Route index element={<Landing />} />
          <Route path="*" element={<Landing />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
